import { getAuthAxiosBackend } from "@/helpers/axios"

class BodySideServices {

    getByGovernorateId(id) {
        return getAuthAxiosBackend().get('' + id.toString())
    }

    get(id) {
        return getAuthAxiosBackend().get('BodySide/getBodySideById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('BodySide/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('BodySide/addBodySide', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('BodySide/updateBodySide/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('BodySide/restoreBodySide' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('BodySide/softDeleteBodySide/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('BodySide/deleteBodySide/' + id.toString())
    }
}

export default new BodySideServices()
